import { createSelector } from "@reduxjs/toolkit";
import { carsPostBookingApi } from "./api";

export const getAllCarReservations = createSelector(
  carsPostBookingApi.endpoints.fetchCarItineraries.select(),
  (res) => res.data
);
